import { render } from "./PayConfig.vue?vue&type=template&id=0444a791&scoped=true"
import script from "./PayConfig.vue?vue&type=script&lang=js"
export * from "./PayConfig.vue?vue&type=script&lang=js"

import "./PayConfig.vue?vue&type=style&index=0&id=0444a791&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0444a791"]])

export default __exports__